import React from 'react';
import '../assets/css/layout/legal.css';

const Terms = () => {
    return (
        <div className="legal-container">
            <div className="legal-header">
                <h1>Terms of Service</h1>
                <p className="last-updated">Last Updated: January 21, 2026</p>
            </div>

            <div className="legal-content">
                <section className="legal-section">
                    <h2>1. Acceptance of Terms</h2>
                    <p>
                        By accessing and using E-AquaHealth&apos;s services, website, and mobile applications 
                        (collectively, the &quot;Platform&quot;), you agree to be bound by these Terms of Service 
                        (&quot;Terms&quot;). If you do not agree to these Terms, please do not use our Platform.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>2. Description of Services</h2>
                    <p>E-AquaHealth provides the following services for aquaculture professionals:</p>
                    <ul>
                        <li><strong>Veterinary Consultation:</strong> Connect with licensed aquatic veterinarians for fish health consultations</li>
                        <li><strong>Laboratory Services:</strong> Access to certified laboratories for water quality testing and disease diagnosis</li>
                        <li><strong>Marketplace:</strong> Purchase aquaculture supplies, equipment, and products from verified vendors</li>
                        <li><strong>Educational Resources:</strong> Online courses and training materials for fish farming</li>
                        <li><strong>AI Chat Support:</strong> Automated assistance for common aquaculture queries</li>
                        <li><strong>Farm Management:</strong> Tools to manage and monitor your aquaculture operations</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>3. User Accounts</h2>
                    <h3>3.1 Registration</h3>
                    <p>
                        To access certain features of the Platform, you must create an account. You agree to:
                    </p>
                    <ul>
                        <li>Provide accurate, current, and complete information during registration</li>
                        <li>Maintain and promptly update your account information</li>
                        <li>Keep your password secure and confidential</li>
                        <li>Notify us immediately of any unauthorized use of your account</li>
                    </ul>

                    <h3>3.2 Account Types</h3>
                    <p>
                        We offer different account types including Fish Farmer, Veterinarian, Laboratory, 
                        and Vendor accounts. Each account type has specific requirements and verification processes.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>4. Professional Services Disclaimer</h2>
                    <p>
                        <strong>Veterinary Services:</strong> While we connect users with licensed veterinarians, 
                        E-AquaHealth is not a veterinary practice. Veterinary advice provided through the Platform 
                        should not replace in-person examinations when necessary.
                    </p>
                    <p>
                        <strong>Laboratory Services:</strong> Laboratory results are provided by independent, 
                        certified laboratories. E-AquaHealth facilitates these services but is not responsible 
                        for the accuracy of individual lab results.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>5. Marketplace Terms</h2>
                    <h3>5.1 Vendor Responsibilities</h3>
                    <p>
                        Vendors on our Platform agree to provide accurate product descriptions, maintain 
                        proper licensing, and comply with all applicable regulations for aquaculture products.
                    </p>

                    <h3>5.2 Buyer Protection</h3>
                    <p>
                        We offer buyer protection for purchases made through our Platform. Disputes should 
                        be reported within 7 days of receiving products.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>6. Prohibited Activities</h2>
                    <p>Users agree not to:</p>
                    <ul>
                        <li>Use the Platform for any unlawful purpose</li>
                        <li>Impersonate any person or entity</li>
                        <li>Upload malicious code or interfere with Platform operations</li>
                        <li>Harvest or collect user information without consent</li>
                        <li>Post false, misleading, or fraudulent content</li>
                        <li>Sell counterfeit or prohibited products</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>7. Intellectual Property</h2>
                    <p>
                        All content on the Platform, including text, graphics, logos, and software, is the 
                        property of E-AquaHealth or its licensors and is protected by intellectual property laws. 
                        You may not reproduce, distribute, or create derivative works without our written permission.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>8. Privacy</h2>
                    <p>
                        Your privacy is important to us. Please review our Privacy Policy to understand how 
                        we collect, use, and protect your personal information.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>9. Limitation of Liability</h2>
                    <p>
                        To the maximum extent permitted by law, E-AquaHealth shall not be liable for any 
                        indirect, incidental, special, consequential, or punitive damages resulting from 
                        your use of the Platform. Our total liability shall not exceed the amount paid by 
                        you to E-AquaHealth in the twelve (12) months preceding the claim.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>10. Modifications to Terms</h2>
                    <p>
                        We reserve the right to modify these Terms at any time. We will notify users of 
                        significant changes via email or Platform notification. Continued use of the Platform 
                        after changes constitutes acceptance of the modified Terms.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>11. Termination</h2>
                    <p>
                        We may suspend or terminate your account at any time for violation of these Terms 
                        or for any other reason at our discretion. You may also terminate your account by 
                        contacting our support team.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>12. Contact Information</h2>
                    <p>
                        For questions about these Terms, please contact us at:
                    </p>
                    <div className="contact-info">
                        <p><strong>Email:</strong> legal@eaquahealth.com</p>
                        <p><strong>Address:</strong> E-AquaHealth Headquarters</p>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Terms;
